var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 95,
    viewBox: "0 0 70 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_42_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.4225 4.31029V90.7055C69.4225 93.0896 67.4963 95.0158 65.1122 95.0158H4.31029C1.92621 95 0 93.0738 0 90.7055V4.31029C0 1.92621 1.92621 0 4.31029 0H65.128C67.4963 0 69.4225 1.92621 69.4225 4.31029Z",
    fill: "url(#paint0_linear_42_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65 7.94666V87.0533C65 89.2363 63.3075 91 61.2126 91H7.78735C5.69252 90.9855 4 89.2218 4 87.0533V7.94666C4 5.76371 5.69252 4 7.78735 4H61.2265C63.3075 4 65 5.76371 65 7.94666Z",
    fill: "url(#paint1_linear_42_1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.8722 18.2516V22.183C26.8722 22.4672 26.6511 22.6882 26.367 22.6882H21.5514C21.2672 22.6882 21.0462 22.9093 21.0462 23.1935V28.009C21.0462 28.2932 20.8252 28.5142 20.541 28.5142H16.6096C16.3254 28.5142 16.1044 28.2932 16.1044 28.009V23.1935C16.1044 22.9093 15.8833 22.6882 15.5991 22.6882H10.7994C10.5152 22.6882 10.2942 22.4672 10.2942 22.183V18.2516C10.2942 17.9674 10.5152 17.7464 10.7994 17.7464H15.6149C15.8991 17.7464 16.1202 17.5254 16.1202 17.2412V12.4256C16.1202 12.1415 16.3412 11.9204 16.6254 11.9204H20.5567C20.8409 11.9204 21.062 12.1415 21.062 12.4256V17.2412C21.062 17.5254 21.283 17.7464 21.5672 17.7464H26.367C26.6511 17.7464 26.8722 17.9674 26.8722 18.2516Z",
    fill: "url(#paint2_linear_42_1)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.5,
    d: "M58.5757 39.6767H10.8468C10.531 39.6767 10.2784 39.4241 10.2784 39.1083V37.2926C10.2784 36.9769 10.531 36.7242 10.8468 36.7242H58.5757C58.8915 36.7242 59.1441 36.9769 59.1441 37.2926V39.1083C59.1283 39.4241 58.8915 39.6767 58.5757 39.6767Z",
    fill: "url(#paint3_linear_42_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.5757 17.0517H34.8928C34.577 17.0517 34.3244 16.7991 34.3244 16.4833V14.6834C34.3244 14.3676 34.577 14.115 34.8928 14.115H58.5757C58.8915 14.115 59.1441 14.3676 59.1441 14.6834V16.4991C59.1283 16.7991 58.8915 17.0517 58.5757 17.0517Z",
    fill: "url(#paint4_linear_42_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.5,
    d: "M51.5656 24.7249H34.8928C34.577 24.7249 34.3244 24.4723 34.3244 24.1565V22.3408C34.3244 22.0251 34.577 21.7725 34.8928 21.7725H51.5656C51.8813 21.7725 52.1339 22.0251 52.1339 22.3408V24.1565C52.1182 24.4723 51.8813 24.7249 51.5656 24.7249Z",
    fill: "url(#paint5_linear_42_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.5,
    d: "M58.5757 48.2973H10.8468C10.531 48.2973 10.2784 48.0447 10.2784 47.7289V45.9132C10.2784 45.5975 10.531 45.3448 10.8468 45.3448H58.5757C58.8915 45.3448 59.1441 45.5975 59.1441 45.9132V47.7289C59.1283 48.0447 58.8915 48.2973 58.5757 48.2973Z",
    fill: "url(#paint6_linear_42_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.5,
    d: "M58.5757 56.9179H10.8468C10.531 56.9179 10.2784 56.6653 10.2784 56.3495V54.5338C10.2784 54.2181 10.531 53.9655 10.8468 53.9655H58.5757C58.8915 53.9655 59.1441 54.2181 59.1441 54.5338V56.3653C59.1283 56.6653 58.8915 56.9179 58.5757 56.9179Z",
    fill: "url(#paint7_linear_42_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.5,
    d: "M58.5757 65.5543H10.8468C10.531 65.5543 10.2784 65.3017 10.2784 64.9859V63.1702C10.2784 62.8544 10.531 62.6018 10.8468 62.6018H58.5757C58.8915 62.6018 59.1441 62.8544 59.1441 63.1702V64.9859C59.1283 65.3017 58.8915 65.5543 58.5757 65.5543Z",
    fill: "url(#paint8_linear_42_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.5,
    d: "M58.5757 74.1749H10.8468C10.531 74.1749 10.2784 73.9223 10.2784 73.6065V71.7908C10.2784 71.475 10.531 71.2224 10.8468 71.2224H58.5757C58.8915 71.2224 59.1441 71.475 59.1441 71.7908V73.6065C59.1283 73.9223 58.8915 74.1749 58.5757 74.1749Z",
    fill: "url(#paint9_linear_42_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.5,
    d: "M58.5757 82.7955H10.8468C10.531 82.7955 10.2784 82.5429 10.2784 82.2271V80.4114C10.2784 80.0956 10.531 79.843 10.8468 79.843H58.5757C58.8915 79.843 59.1441 80.0956 59.1441 80.4114V82.2271C59.1283 82.5429 58.8915 82.7955 58.5757 82.7955Z",
    fill: "url(#paint10_linear_42_1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.1,
    d: "M69.4225 4.31029V90.7055C69.4225 93.0896 67.4963 95.0158 65.1122 95.0158H4.31029C1.92621 95 0 93.0738 0 90.7055V89.2056C37.0874 73.8906 54.3601 15.1571 58.2599 0H65.1122C67.4963 0 69.4225 1.92621 69.4225 4.31029Z",
    fill: "#1A6FB5",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_1",
    x1: 95,
    y1: 126,
    x2: -6,
    y2: -5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    stopColor: "#5BA7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_1",
    x1: 8.6241,
    y1: 7.04564,
    x2: 57.9385,
    y2: 78.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_42_1",
    x1: 10,
    y1: 9.50003,
    x2: 25,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368525,
    stopColor: "#80E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CDDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_42_1",
    x1: 10.2906,
    y1: 38.2072,
    x2: 59.1355,
    y2: 38.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_42_1",
    x1: 34.3248,
    y1: 15.5844,
    x2: 59.1355,
    y2: 15.5844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_42_1",
    x1: 34.3248,
    y1: 23.2616,
    x2: 52.1256,
    y2: 23.2616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_42_1",
    x1: 10.2906,
    y1: 46.8317,
    x2: 59.1355,
    y2: 46.8317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_42_1",
    x1: 10.2906,
    y1: 55.4562,
    x2: 59.1355,
    y2: 55.4562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_42_1",
    x1: 10.2906,
    y1: 64.0807,
    x2: 59.1355,
    y2: 64.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_42_1",
    x1: 10.2906,
    y1: 72.7052,
    x2: 59.1355,
    y2: 72.7052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_42_1",
    x1: 10.2906,
    y1: 81.3297,
    x2: 59.1355,
    y2: 81.3297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.4225,
    height: 95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.7d50799bbbf70b3b8887ce5542ae3923.svg";
export { ForwardRef as ReactComponent };